<template>
  <v-app id="inspire">
    <div class="payroll-settings-wrap">
      <v-layout class="wrap xs12">
        <v-layout>
          <v-flex class="mb-4">
            <div class="billing-top-header">
              <div class="caption mb-2">
                <span 
                  @click="$router.push('/settings')"
                  class="pointer primary--text text-uppercase"
                >Settings</span>
                <span class="px-2 grey--text">/</span>
                <span 
                  class="grey--text text-uppercase"
                >Payroll</span>
              </div>
              <h2 class="headline">Payroll</h2>
            </div>
          </v-flex>
        </v-layout>
        <v-spacer></v-spacer>
        <v-layout v-if="organizationSettings" class="wrap justify-end">
          <v-menu offset-y bottom left>
            <template v-slot:activator="{ on }">
              <v-btn class="mr-0 mt-0" v-on="on" icon>
                <v-icon color="#999">more_vert</v-icon>
              </v-btn>
            </template>
            <v-list class="pa-0">
              <v-list-item @click="vEmit({ name: 'EditPayrollFilter' })">
                <v-flex class="body-1">
                  <v-icon class="mr-2" size="20px">filter_list</v-icon>
                  Show/Hide Payroll Info
                </v-flex>
              </v-list-item>
              <v-list-item @click="editPayPeriodModal">
                <v-flex class="body-1">
                  <v-icon class="mr-2" size="20px">date_range</v-icon>
                  Edit Pay Period
                </v-flex>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-btn
            @click="editFieldtechModal"
            sx12
            class="mr-0 mt-0 mb-2 ml-1"
            color="primary"
            dark
          >
            Edit Fieldtech App Settings
          </v-btn>
        </v-layout>
      </v-layout>
      <v-layout>
        <p class="body-2">Please update pay rates starting on Mon {{ `${weekStart}${payPeriodName ? ' (Pay period: ' + payPeriodName + ')' : ''}` }}</p>
      </v-layout>

      <v-card>
        <v-data-table
          :headers="filtered_headers"
          :items="items"
          :options.sync="options"
          :server-items-length="totalItems"
          :loading="loading || payrollLoading"
          loader-height="2"
          :footer-props="{'items-per-page-options': [10, 20, 50, 100]}"
          class="elevation-1 table-org my-sticky-first-column-table my-sticky-last-column-table"
          :header-props="{ 'sort-icon': 'arrow_downward' }"
          mobile-breakpoint="100"
        >
          <template v-slot:item="{item}">
            <tr class="items-body-row">
              <td>
                <router-link
                  v-bind:to="'/staff/' + item.employee_id + '/show'"
                  >{{ item.last_name }}</router-link
                >
              </td>
              <td>
                <router-link
                  v-bind:to="'/staff/' + item.employee_id + '/show'"
                  >{{ item.first_name }}</router-link
                >
              </td>
              <td>
                <v-flex>
                  <template v-if="!no_data.includes(item.hire_date)">{{
                    item.hire_date
                  }}</template>
                  <em v-else class="grey--text">No data</em>
                </v-flex>
              </td>
              <td v-if="activePayrollData.includes('years_in_service')">
                <v-flex>
                  <template
                    v-if="!no_data.includes(item.years_in_service)"
                    >{{ item.years_in_service }}</template
                  >
                  <em v-else class="grey--text">No data</em>
                </v-flex>
              </td>
              <td v-if="activePayrollData.includes('mileage_rate')">
                <template v-if="!no_data.includes(item.mileage_rate)">{{
                  `$${item.mileage_rate} / mi.`
                }}</template>
                <em v-else class="grey--text">No data</em>
              </td>
              <td v-if="activePayrollData.includes('hourly_rate')">
                <template v-if="!no_data.includes(item.hourly_rate)">{{
                  `$${item.hourly_rate} / hr.`
                }}</template>
                <em v-else class="grey--text">No data</em>
              </td>
              <td v-if="activePayrollData.includes('base_percentage')">
                <template v-if="!no_data.includes(item.revenue_rate)">{{
                  `${item.revenue_rate}%`
                }}</template>
                <em v-else class="grey--text">No data</em>
              </td>
              <td v-if="activePayrollData.includes('yard_rate')">
                <template v-if="!no_data.includes(item.yard_rate)">{{
                  `$${item.yard_rate} / yard`
                }}</template>
                <em v-else class="grey--text">No data</em>
              </td>
              <td v-if="activePayrollData.includes('fixed_rate')">
                <template v-if="!no_data.includes(item.fixed_rate)">{{
                  `$${item.fixed_rate} ${['week', 'month'].includes(payPeriodPer) ? '/ ' : ''}${payPeriodPer}`
                }}</template>
                <em v-else class="grey--text">No data</em>
              </td>
              <td>
                <template
                  v-if="!no_data.includes(item.min_revenue_per_hour)"
                  >{{ `$${item.min_revenue_per_hour}` }}</template
                >
                <em v-else class="grey--text">No data</em>
              </td>
              <td>
                <template
                  v-if="!no_data.includes(item.min_revenue_per_mile)"
                  >{{ `$${item.min_revenue_per_mile}` }}</template
                >
                <em v-else class="grey--text">No data</em>
              </td>
              <td>
                <template
                  v-if="
                    !no_data.includes(item.affecting_company_averages)
                  "
                  >{{
                    item.affecting_company_averages === 1 ? "Yes" : "No"
                  }}</template
                >
                <em v-else class="grey--text">No data</em>
              </td>
              <td class="actions-position1">
                <v-flex style="min-width: 60px;">
                  <v-flex
                    @click="editPayrollModal(item)"
                    class="action-link"
                    >Edit <v-icon>edit</v-icon></v-flex
                  >
                </v-flex>
              </td>
            </tr>
          </template>
          <template
            slot="no-data"
            v-if="error_code == 404 || error_code == 500"
          >
            <v-btn color="primary" @click="initialize()">Reset</v-btn>
          </template>
        </v-data-table>
      </v-card>

      <!-- Edit Payroll Dialog -->
      <v-dialog
        v-if="editPayrollDialog"
        v-model="editPayrollDialog"
        max-width="500px"
        persistent
      >
        <v-card class="pa-4">
          <div>
            <v-card-title>
              <h2 class="title">Edit Payroll for {{ editingStaffName }}</h2>
            </v-card-title>
            <div class="py-4 px-6">
              <v-flex xs12>
                <v-text-field
                  label="Mileage Rate ($/mi)*"
                  v-model="editPayrollData.mileage_rate"
                  placeholder="Please Enter"
                  suffix="$/mi"
                  :error-messages="
                    errors($v.editPayrollData.mileage_rate) ||
                      server_errors.mileage_rate
                  "
                  @blur="$v.editPayrollData.mileage_rate.$touch()"
                  @focus="resetServerValidation"
                ></v-text-field>
                <v-select
                  :items="payrollMethods"
                  label="Payroll Method"
                  item-text="text"
                  item-value="value"
                  v-model="selectedPayrollMethod"
                  placeholder="Please Select"
                  @focus="resetServerValidation"
                >
                </v-select>
                <v-text-field
                  v-if="selectedPayrollMethod === 'hourly_pay'"
                  label="Hourly Rate ($/hr)*"
                  v-model="editPayrollData.hourly_rate"
                  placeholder="Please Enter"
                  suffix="$/hr"
                  :error-messages="
                    errors($v.editPayrollData.hourly_rate) ||
                      server_errors.hourly_rate
                  "
                  @blur="$v.editPayrollData.hourly_rate.$touch()"
                  @focus="resetServerValidation"
                ></v-text-field>
                <v-text-field
                  v-if="selectedPayrollMethod === 'yard_pay'"
                  label="Yard Rate ($/yard)*"
                  v-model="editPayrollData.yard_rate"
                  placeholder="Please Enter"
                  suffix="$/yard"
                  :error-messages="
                    errors($v.editPayrollData.yard_rate) ||
                      server_errors.yard_rate
                  "
                  @blur="$v.editPayrollData.yard_rate.$touch()"
                  @focus="resetServerValidation"
                ></v-text-field>
                <v-text-field
                  v-if="selectedPayrollMethod === 'fixed_pay'"
                  :label="`Fixed Rate ($${['week', 'month'].includes(payPeriodPer) ? '/' : ' '}${payPeriodPer})*`"
                  v-model="editPayrollData.fixed_rate"
                  placeholder="Please Enter"
                  :suffix="`$${['week', 'month'].includes(payPeriodPer) ? '/' : ' '}${payPeriodPer}`"
                  :error-messages="
                    errors($v.editPayrollData.fixed_rate) ||
                      server_errors.fixed_rate
                  "
                  @blur="$v.editPayrollData.fixed_rate.$touch()"
                  @focus="resetServerValidation"
                ></v-text-field>
                <v-text-field
                  v-if="selectedPayrollMethod === 'hourly_pay'"
                  class="mb-4"
                  label="Base Percentage (%)*"
                  v-model="editPayrollData.revenue_rate"
                  placeholder="Please Enter"
                  suffix="%"
                  hint="Example: 32.00 means 32%"
                  persistent-hint
                  :error-messages="
                    errors($v.editPayrollData.revenue_rate) ||
                      server_errors.revenue_rate
                  "
                  @blur="$v.editPayrollData.revenue_rate.$touch()"
                  @focus="resetServerValidation"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  label="Minimum revenue per hour"
                  v-model="editPayrollData.min_revenue_per_hour"
                  prefix="$"
                  placeholder="Please Enter"
                  :error-messages="
                    errors($v.editPayrollData.min_revenue_per_hour) ||
                      server_errors.min_revenue_per_hour
                  "
                  @blur="$v.editPayrollData.min_revenue_per_hour.$touch()"
                  @focus="resetServerValidation"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  label="Minimum revenue per mile"
                  v-model="editPayrollData.min_revenue_per_mile"
                  prefix="$"
                  placeholder="Please Enter"
                  :error-messages="
                    errors($v.editPayrollData.min_revenue_per_mile) ||
                      server_errors.min_revenue_per_mile
                  "
                  @blur="$v.editPayrollData.min_revenue_per_mile.$touch()"
                  @focus="resetServerValidation"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-checkbox
                  label="Affecting company averages"
                  v-model="editPayrollData.affecting_company_averages"
                >
                </v-checkbox>
              </v-flex>

              <v-alert
                class="pa-2 mt-4"
                :value="$v.editPayrollData.$error"
                outlined
                color="error"
                icon="priority_high"
                transition="scale-transition"
              >
                <span class="caption">Please fill out form correctly</span>
              </v-alert>
              <v-alert
                class="pa-2 mt-4"
                :value="!serverValidation"
                outlined
                color="error"
                icon="priority_high"
                transition="scale-transition"
              >
                <span class="caption">{{ serverValidationMessage }}</span>
              </v-alert>
            </div>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="closeEditPayroll"
                >Cancel</v-btn
              >
              <v-btn
                color="primary"
                :loading="saveEditPayrollLoading"
                :disabled="saveEditPayrollLoading"
                @click="editPayroll"
                >Save</v-btn
              >
            </v-card-actions>
          </div>
        </v-card>
      </v-dialog>

      <v-dialog
        v-if="editFieldtechDialog"
        v-model="editFieldtechDialog"
        max-width="500px"
        persistent
      >
        <v-card class="pa-4">
          <v-card-title>
            <h2 class="title">Edit Fieldtech App Settings</h2>
            <v-progress-linear
              :indeterminate="loadingOrganizationSettings"
              class="mb-0 mt-4"
              :class="{ 'no-opacity': !loadingOrganizationSettings }"
              style="height: 2px;"
            ></v-progress-linear>
          </v-card-title>
          <div class="py-4 px-6">
            <v-flex class="xs12">
              <v-switch
                v-model="editFieldtechData.show_payroll_filed_tech"
                label="Show Payroll on Fieldtech App"
              ></v-switch>
            </v-flex>
            <v-alert
              class="pa-2 mt-4"
              :value="!serverValidation"
              outlined
              color="error"
              icon="priority_high"
              transition="scale-transition"
            >
              <span class="caption">{{ serverValidationMessage }}</span>
            </v-alert>
          </div>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="closeEditFieldtech"
              >Cancel</v-btn
            >
            <v-btn
              color="primary"
              :loading="editFieldtechLoading"
              :disabled="editFieldtechLoading || loadingOrganizationSettings"
              @click="editFieldtech"
              >Save</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-if="editPayPeriodDialog"
        v-model="editPayPeriodDialog"
        max-width="500px"
        persistent
      >
        <v-card class="pa-0 pa-sm-4">
          <v-card-title class="px-4 pb-0">
            <h2 class="title">Edit Pay Period</h2>
            <v-progress-linear
              :indeterminate="loadingOrganizationSettings"
              class="mb-0 mt-4"
              :class="{ 'no-opacity': !loadingOrganizationSettings }"
              style="height: 2px;"
            ></v-progress-linear>
          </v-card-title>
          <div class="py-4 px-4 px-sm-6">
            <v-flex class="xs12">
              <v-autocomplete
                  :items="payPeriods"
                  label="Pay Period"
                  item-text="text"
                  item-value="value"
                  v-model="editPayPeriodData.pay_period"
                  placeholder="Please Select"
                  @focus="resetServerValidation"
                >
                <template v-slot:item="data">
                  <v-list-item-content>
                    <v-list-item-title v-html="data.item.text"></v-list-item-title>
                    <v-list-item-subtitle v-html="data.item.description"></v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-flex>
            <v-alert
              class="pa-2 mt-4"
              :value="!serverValidation"
              outlined
              color="error"
              icon="priority_high"
              transition="scale-transition"
            >
              <span class="caption">{{ serverValidationMessage }}</span>
            </v-alert>
          </div>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="closePayPeriod"
              >Cancel</v-btn
            >
            <v-btn
              color="primary"
              :loading="editPayPeriodLoading"
              :disabled="editPayPeriodLoading || loadingOrganizationSettings"
              @click="editPayPeriod"
              >Save</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <edit-payroll-filter @done="initialize"></edit-payroll-filter>
    </div>
  </v-app>
</template>

<script>
import ApiService from "@/common/api.service"
import { validationMixin } from "vuelidate"
import { required, decimal, helpers } from "vuelidate/lib/validators"
import { valMessages, getValMessage } from "@/common/error-messages"
import { mapGetters, mapActions } from 'vuex'
import EditPayrollFilter from './EditPayrollFilter'

const validations = {
  editPayrollData: {
    mileage_rate: {
      required,
      decimal,
      notNegative: v => !helpers.req(v) || v >= 0,
      currency: v => !helpers.req(v) || /^([1-9][0-9]*)+(\.[0-9]{1,2})?$/.test(v) || /^0+(\.[0-9]{1,2})?$/.test(v)
    },
    hourly_rate: {
      required,
      decimal,
      notNegative: v => !helpers.req(v) || v >= 0,
      currency: v => !helpers.req(v) || /^([1-9][0-9]*)+(\.[0-9]{1,2})?$/.test(v) || /^0+(\.[0-9]{1,2})?$/.test(v)
    },
    fixed_rate: {
      required,
      decimal,
      notNegative: v => !helpers.req(v) || v >= 0,
      currency: v => !helpers.req(v) || /^([1-9][0-9]*)+(\.[0-9]{1,2})?$/.test(v) || /^0+(\.[0-9]{1,2})?$/.test(v)
    },
    yard_rate: {
      required,
      decimal,
      notNegative: v => !helpers.req(v) || v >= 0,
      currency: v => !helpers.req(v) || /^([1-9][0-9]*)+(\.[0-9]{1,2})?$/.test(v) || /^0+(\.[0-9]{1,2})?$/.test(v)
    },
    revenue_rate: {
      required,
      decimal,
      notNegative: v => !helpers.req(v) || v >= 0
    },
    min_revenue_per_hour: {
      decimal,
      notNegative: v => !helpers.req(v) || v >= 0,
      currency: v => !helpers.req(v) || /^([1-9][0-9]*)+(\.[0-9]{1,2})?$/.test(v) || /^0+(\.[0-9]{1,2})?$/.test(v)
    },
    min_revenue_per_mile: {
      decimal,
      notNegative: v => !helpers.req(v) || v >= 0,
      currency: v => !helpers.req(v) || /^([1-9][0-9]*)+(\.[0-9]{1,2})?$/.test(v) || /^0+(\.[0-9]{1,2})?$/.test(v)
    }
  }
};

export default {
  mixins: [validationMixin],
  validations,
  name: "PayrollSettings",
  components: {
    EditPayrollFilter
  },
  data: () => ({
    dialog: false,
    editPayrollDialog: false,
    no_data: [null, "", undefined, "null"],
    headers: [
      { 
        text: "Last Name", 
        sortable: true, 
        sort_column: 0,
        value: "last_name", 
        align: "left",
        width: 130,
        payroll_filter: 'default'
      },
      {
        text: "First Name",
        sortable: true,
        sort_column: 1,
        value: "first_name",
        align: "left",
        width: 120,
        payroll_filter: 'default'
      },
      {
        text: "Hire Date",
        sortable: false,
        value: "hire_date",
        align: "left",
        width: 110,
        payroll_filter: 'default'
      },
      {
        text: "Years in Service (year/month)",
        sortable: false,
        value: "years_in_service",
        align: "left",
        width: 130,
        payroll_filter: 'years_in_service'
      },
      {
        text: "Mileage Rate ($/mi)",
        sortable: false,
        value: "mileage_rate",
        align: "left",
        width: 120,
        payroll_filter: 'mileage_rate'
      },
      {
        text: "Hourly Rate ($/hr)",
        sortable: false,
        value: "hourly_rate",
        align: "left",
        width: 120,
        payroll_filter: 'hourly_rate'
      },
      {
        text: "Base Percentage (%)",
        sortable: false,
        value: "base_percentage",
        align: "left",
        width: 120,
        payroll_filter: 'base_percentage'
      },
      {
        text: "Yard Rate ($/yard)",
        sortable: false,
        value: "yard_rate",
        align: "left",
        width: 110,
        payroll_filter: 'yard_rate'
      },
      {
        text: "Fixed Rate ($/pay period)",
        sortable: false,
        value: "fixed_rate",
        align: "left",
        width: 120,
        payroll_filter: 'fixed_rate'
      },
      {
        text: "Min revenue per mile ($)",
        sortable: false,
        value: "min_revenue_per_mile",
        align: "left",
        width: 120,
        payroll_filter: 'default'
      },
      {
        text: "Min revenue per hour ($)",
        sortable: false,
        value: "min_revenue_per_hour",
        align: "left",
        width: 110,
        payroll_filter: 'default'
      },
      {
        text: "Affecting company averages",
        sortable: false,
        value: "affecting_company_averages",
        align: "left",
        width: 140,
        payroll_filter: 'default'
      },
      {
        text: "Actions",
        sortable: false,
        align: "left",
        width: 60,
        class: "actions-position1",
        payroll_filter: 'default'
      }
    ],
    payrollMethods: [
      { text: "Pay per Hour + Base Percentage", value: "hourly_pay" },
      { text: "Pay per Yard", value: "yard_pay" },
      { text: "Fixed Pay", value: "fixed_pay" }
    ],
    selectedPayrollMethod: "hourly_pay",
    items: [],
    totalItems: 0,
    search: "",
    options: {},
    loading: false,
    payrollLoading: false,
    draw: 0,
    tableData: {
      draw: 0,
      length: 10,
      search: "",
      page: 0,
      column: 0,
      dir: "asc",
      status: null,
      roles: null
    },
    error_code: "",
    editPayrollData: {},
    editingStaffName: null,

    organization_settings: { pay_period: 'weekly' },

    editFieldtechDialog: false,
    editFieldtechLoading: false,
    editFieldtechData: {},
    loadingOrganizationSettings: false,

    editPayPeriodDialog: false,
    editPayPeriodLoading: false,
    editPayPeriodData: {},
    payPeriods: [
      { text: "Weekly", value: "weekly", description: 'Mon-Sun' },
      { text: "Twice per Month", value: "twice_per_month", description: '1st-15th & 16th-End of Month' },
      { text: "Bi-weekly", value: "bi_weekly", description: 'Every 2 Weeks' },
      { text: "Monthly", value: "monthly", description: '1st-End of Month' }
    ],

    payrollFilter: [
      { 'slug': 'years_in_service', 'name': 'Years in Service', 'show': true, 'defaultShow': true }, 
      { 'slug': 'worked_hours', 'name': 'Worked Hours', 'show': true, 'defaultShow': true }, 
      
      { 'slug': 'residential_revenue', 'name': 'Residential Revenue', 'show': true, 'defaultShow': false },
      { 'slug': 'residential_bonus', 'name': 'Additional Residential Services Revenue', 'show': true, 'defaultShow': false },
      { 'slug': 'commercial_revenue', 'name': 'Commercial Revenue', 'show': true, 'defaultShow': false },
      { 'slug': 'commercial_bonus', 'name': 'Additional Commercial Services Revenue', 'show': true, 'defaultShow': false },
      
      { 'slug': 'revenue', 'name': 'Revenue', 'show': true, 'defaultShow': true }, 
      { 'slug': 'revenue_adjustment', 'name': 'Revenue Adjustment', 'show': true, 'defaultShow': true }, 
      { 'slug': 'distance', 'name': 'Distance', 'show': true, 'defaultShow': true }, 
      { 'slug': 'regular_hours', 'name': 'Regular Hours', 'show': true, 'defaultShow': true }, 
      { 'slug': 'overtime_hours', 'name': 'Overtime Hours', 'show': true, 'defaultShow': true }, 
      { 'slug': 'holiday', 'name': 'Holiday Hours', 'show': true, 'defaultShow': true }, 
      { 'slug': 'vacation_hours', 'name': 'Vacation Hours', 'show': true, 'defaultShow': true }, 
      { 'slug': 'pto_hours', 'name': 'PTO', 'show': true, 'defaultShow': true }, 
      { 'slug': 'tips', 'name': 'Tips', 'show': true, 'defaultShow': true }, 
      { 'slug': 'addl_bonus', 'name': 'Addl Bonus', 'show': true, 'defaultShow': true }, 
      { 'slug': 'reimbursement', 'name': 'Msc Reimb', 'show': true, 'defaultShow': true }, 
      { 'slug': 'deduction', 'name': 'Deductions', 'show': true, 'defaultShow': true }, 
      { 'slug': 'number_of_jobs', 'name': 'Nr of Jobs', 'show': true, 'defaultShow': true }, 
      { 'slug': 'number_of_complaints', 'name': 'Nr of Complaints', 'show': true, 'defaultShow': true }, 
      { 'slug': 'mileage_rate', 'name': 'Mileage Rate', 'show': true, 'defaultShow': true }, 
      { 'slug': 'hourly_rate', 'name': 'Hourly Rate', 'show': true, 'defaultShow': true }, 
      { 'slug': 'base_percentage', 'name': 'Base Percentage', 'show': true, 'defaultShow': true }, 
      { 'slug': 'yard_rate', 'name': 'Per Yard Rate', 'show': true, 'defaultShow': true }, 
      { 'slug': 'fixed_rate', 'name': 'Fixed Rate', 'show': true, 'defaultShow': true }
    ],

    saveEditPayrollLoading: false,
    formValidation: true,
    serverValidation: true,
    serverValidationMessage: "Oops something went wrong...",
    server_errors: {}
  }),

  watch: {
    dialog(val) {
      val || this.close();
    },
    options: {
      handler() {
        if (this.draw !== this.tableData.draw) {
          this.getPayroll();
        }
      },
      deep: true
    },
    search: _.debounce(function() {
      this.typing = false;
      if (this.draw !== this.tableData.draw) {
        this.options.page = 1;
        this.getPayroll();
      }
    }, 1000)
  },
  mounted() {
    this.initialize();
  },
  methods: {
    ...mapActions(['checkOrganizationSettings', 'vEmit']),
    initialize() {
      this.loading = true
      Promise.all([this.getPayroll(), this.getOrganizationSettings()])
        .then(values => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
        })
    },
    getPayroll() {
      this.payrollLoading = true;
      return new Promise((resolve, reject) => {
        const { sortBy, sortDesc, page, itemsPerPage } = this.options;

        this.tableData.column = 0;
        if (
          !this.no_data.includes(sortBy) &&
          !this.no_data.includes(sortBy[0]) &&
          this.headers.some(i => i.value === sortBy[0] && i.sortable !== false)
        ) {
          this.tableData.column = this.headers.find(
            i => i.value === sortBy[0]
          ).sort_column;
        }
        this.tableData.dir = !this.no_data.includes(sortDesc) && sortDesc[0] === true ? "desc" : "asc";
        this.tableData.length = itemsPerPage;
        this.tableData.page = page;
        this.tableData.search = this.search;
        this.tableData.draw++;
        this.draw = this.tableData.draw;

        ApiService.get("/payroll/pay_rate", this.tableData).then(response => {
          this.draw++;
          this.items = response.data.pay_rates.data;
          this.totalItems = response.data.pay_rates.total;
          this.payrollLoading = false;
          resolve()
        })
        .catch(error => {
          this.payrollLoading = false;
          reject()
        })
      })
    },
    getOrganizationSettings(mandatory = false) {
      this.loadingOrganizationSettings = true;
      return new Promise((resolve, reject) => {
      this.checkOrganizationSettings(mandatory)
        .then(response => {
          let organization_settings = {
            pay_period: 'weekly',
            ...response
          }
          organization_settings.show_payroll_filed_tech = Boolean(
            Number(organization_settings.show_payroll_filed_tech)
          )
          if(response.payroll_filter) {
            let filter_value = response.payroll_filter.split(',')
            this.payrollFilter.forEach(i => { i.show = filter_value.includes(i.slug)})
          }
          this.organization_settings = organization_settings;
          this.loadingOrganizationSettings = false;
          resolve()
        })
        .catch(error => {
          console.log(error);
          this.loadingOrganizationSettings = false;
          reject()
        });
      })
    },
    getIndex(array, key, value) {
      return array.findIndex(i => i[key] == value);
    },
    editPayrollModal(item) {
      this.editPayrollDialog = true;
      this.$v.$reset();
      this.resetServerValidation();
      this.editPayrollData = {
        staff_id: item.employee_id,
        revenue_rate: !this.no_data.includes(item.revenue_rate)
          ? item.revenue_rate
          : "0.00",
        mileage_rate: !this.no_data.includes(item.mileage_rate)
          ? item.mileage_rate
          : "0.00",
        hourly_rate: !this.no_data.includes(item.hourly_rate)
          ? item.hourly_rate
          : "0.00",
        fixed_rate: !this.no_data.includes(item.fixed_rate)
          ? item.fixed_rate
          : "0.00",
        yard_rate: !this.no_data.includes(item.yard_rate)
          ? item.yard_rate
          : "0.00",
        min_revenue_per_hour: !this.no_data.includes(item.min_revenue_per_hour)
          ? item.min_revenue_per_hour
          : "0.00",
        min_revenue_per_mile: !this.no_data.includes(item.min_revenue_per_mile)
          ? item.min_revenue_per_mile
          : "0.00",
        affecting_company_averages: !this.no_data.includes(
          item.affecting_company_averages
        )
          ? item.affecting_company_averages
          : 0
      };
      if (
        parseFloat(this.editPayrollData.hourly_rate) >= 0 &&
        parseFloat(this.editPayrollData.yard_rate) === 0 &&
        parseFloat(this.editPayrollData.fixed_rate) === 0
      ) {
        this.selectedPayrollMethod = "hourly_pay";
      } else if (
        parseFloat(this.editPayrollData.yard_rate) > 0 &&
        parseFloat(this.editPayrollData.hourly_rate) === 0 &&
        parseFloat(this.editPayrollData.fixed_rate) === 0
      ) {
        this.selectedPayrollMethod = "yard_pay";
      } else if (
        parseFloat(this.editPayrollData.fixed_rate) > 0 &&
        parseFloat(this.editPayrollData.hourly_rate) === 0 &&
        parseFloat(this.editPayrollData.yard_rate) === 0
      ) {
        this.selectedPayrollMethod = "fixed_pay";
      } else {
        this.selectedPayrollMethod = "hourly_pay";
      }
      this.editingStaffName = `${item.first_name} ${item.last_name}`;
    },
    editPayroll() {
      this.resetServerValidation();
      this.$v.editPayrollData.$touch();
      if (this.selectedPayrollMethod === "hourly_pay") {
        this.editPayrollData.fixed_rate = "0.00";
        this.editPayrollData.yard_rate = "0.00";
      } else if (this.selectedPayrollMethod === "yard_pay") {
        this.editPayrollData.hourly_rate = "0.00";
        this.editPayrollData.revenue_rate = "0.00";
        this.editPayrollData.fixed_rate = "0.00";
      } else {
        this.editPayrollData.hourly_rate = "0.00";
        this.editPayrollData.revenue_rate = "0.00";
        this.editPayrollData.yard_rate = "0.00";
      }
      let body = {...this.editPayrollData}
      if(this.no_data.includes(this.editPayrollData.min_revenue_per_hour)) {
        body.min_revenue_per_hour = "0.00"
      }
      if(this.no_data.includes(this.editPayrollData.min_revenue_per_mile)) {
        body.min_revenue_per_mile = "0.00"
      }
      if (!this.$v.editPayrollData.$invalid) {
        this.saveEditPayrollLoading = true;
        ApiService.put("/payroll/pay_rate", {
          pay_rate: [body]
        })
          .then(response => {
            this.getPayroll();
            this.vEmit({ 
              name: "notification", 
              data: {
                status: "success",
                text: "Payroll has been successfully edited."
              }
            });
            this.saveEditPayrollLoading = false;
            this.closeEditPayroll();
          })
          .catch(({ response }) => {
            this.saveEditPayrollLoading = false;
            this.serverValidation = false;
            if (response.data.error) {
              this.serverValidationMessage = this.titleCase(
                response.data.error
              );
            }
            if (response.data.message) {
              this.serverValidationMessage = response.data.message;
            }
            if (response.data.errors) {
              if (typeof response.data.errors === "string") {
                this.serverValidationMessage = response.data.errors;
              } else {
                this.server_errors = response.data.errors;
              }
            }
          });
      }
    },
    closeEditPayroll() {
      this.editPayrollDialog = false;
    },
    editFieldtechModal() {
      this.editFieldtechDialog = true;
      this.editFieldtechData = { ...this.organization_settings };
      // delete this.editBrandingData.logo
      this.resetServerValidation();
    },
    editFieldtech() {
      let body = {
        organization_settings: [
          {
            key: "show_payroll_filed_tech",
            value: this.editFieldtechData.show_payroll_filed_tech
          }
        ]
      };
      this.editFieldtechLoading = true;
      this.resetServerValidation();

      ApiService.put("/organization_settings", body)
        .then(response => {
          this.editFieldtechLoading = false;
          this.vEmit({ 
            name: "notification", 
            data: {
              status: "success",
              text: "Fieldtech App Settings has been successfully edited."
            }
          });
          this.closeEditFieldtech();
          this.getOrganizationSettings(true);
        })
        .catch(({ response }) => {
          this.editFieldtechLoading = false;
          this.serverValidation = false;
          if (response.data.error) {
            this.serverValidationMessage = this.titleCase(response.data.error);
          }
          if (response.data.message) {
            this.serverValidationMessage = response.data.message;
          }
          if (response.data.errors) {
            if (typeof response.data.errors === "string") {
              this.serverValidationMessage = response.data.errors;
            } else {
              this.server_errors = response.data.errors;
            }
          }
        });
    },
    closeEditFieldtech() {
      this.editFieldtechDialog = false;
    },
    editPayPeriodModal() {
      this.editPayPeriodData = { ...this.organization_settings };
      this.editPayPeriodDialog = true;
      this.resetServerValidation();
    },
    editPayPeriod() {
      let body = {
        organization_settings: [
          {
            key: "pay_period",
            value: this.editPayPeriodData.pay_period
          }
        ]
      };
      this.editPayPeriodLoading = true;
      this.resetServerValidation();

      ApiService.put("/organization_settings", body)
        .then(response => {
          this.editPayPeriodLoading = false;
          this.vEmit({ 
            name: "notification", 
            data: {
              status: "success",
              text: "Pay Period has been successfully edited."
            }
          });
          this.closePayPeriod();
          this.getOrganizationSettings(true);
        })
        .catch(({ response }) => {
          this.editPayPeriodLoading = false;
          this.serverValidation = false;
          if (response.data.error) {
            this.serverValidationMessage = this.titleCase(response.data.error);
          }
          if (response.data.message) {
            this.serverValidationMessage = response.data.message;
          }
          if (response.data.errors) {
            if (typeof response.data.errors === "string") {
              this.serverValidationMessage = response.data.errors;
            } else {
              this.server_errors = response.data.errors;
            }
          }
        });
    },
    closePayPeriod() {
      this.editPayPeriodDialog = false;
    },
    changeSort(column) {
      if (this.options.sortBy[0] === column) {
        this.options.sortDesc[0] = !this.options.sortDesc[0];
      } else {
        this.options.sortBy[0] = column;
        this.options.sortDesc[0] = false;
      }
    },
    titleCase(str) {
      return _.startCase(str.replace(/_/g, " "));
    },
    resetServerValidation() {
      this.serverValidation = true;
      this.serverValidationMessage = "Oops something went wrong...";
      this.server_errors = {};
    },
    errors: getValMessage(valMessages)(validations)
  },
  computed: {
    ...mapGetters([
      'organizationSettings',
      'payPeriodDays',
      'payPeriodStart',
      'payPeriodName',
      'payPeriodPer'
    ]),
    weekStart() {
      return moment(this.payPeriodStart(moment().format("YYYY[-]MM[-]DD"))).format("MM[-]DD[-]YY")
    },
    activePayrollData() {
      return this.payrollFilter.filter(i => i.show).map(i => i.slug)
    },
    filtered_headers() {
      return this.headers.filter(i => this.activePayrollData.includes(i.payroll_filter) || i.payroll_filter === 'default')
    }
  }
};
</script>
<style>
/**tools table**/
.payroll-settings-wrap div.datatable.table {
  margin-bottom: 0%;
}

.payroll-settings-wrap .header-search-single {
  padding-bottom: 20px;
}

/*Search field width*/
.search-org {
  min-width: 120px;
}

td a {
  text-decoration: none;
}

.dialog-heading {
  background-color: #efefef;
  padding: 10px;
}

.no-opacity {
  opacity: 0;
}

.clear-filters {
  text-transform: none;
  color: #00838F;
  cursor: pointer;
  text-decoration: underline;
  font-size: 14px;
}

.payroll-settings-wrap .table-head-text {
  white-space: normal;
  text-align: left;
  min-width: 100px;
}

.table-org td.actions-position {
  position: absolute;
  right: 0;
  border-left: 1px solid rgba(0, 0, 0, 0.12) !important;
  border-top: none !important;
  border-bottom: none !important;
  padding-top: 13px !important;
  padding-bottom: 13px !important;
  background: #fff;

  -webkit-transition: background 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  transition: background 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  will-change: background;
}

.table-org th.actions-position::before {
  content: "Actions";
  position: absolute;
  top: 0;
  right: 0;
  padding: 19px 24px;
  border-left: 1px solid rgba(0, 0, 0, 0.12) !important;
  border-top: none !important;
  border-bottom: none !important;
  text-align: left;
  width: 109px;
  height: 56px;
  background: #fff;
}

.table-org th.actions-position {
  width: 108px !important;
}

.table-org tr:not(:nth-child(1)) td.actions-position {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
}

.table-org tr:hover td.actions-position {
  background: #e0f5f8;
}

.payroll-data-select div.v-input__slot {
    margin-bottom: 0!important;
}
</style>
